import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  useToast,
} from '@chakra-ui/react';
import { CreateCalculation, UpdateCalculation } from '../api/calculation';

const CalculationModalComponent = ({
  isOpen,
  onClose,
  calculation,
  onSuccess,
}) => {
  const toast = useToast();
  const [name, setName] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset form fields whenever modal is opened
  useEffect(() => {
    if (isOpen) {
      setName(calculation?.name || '');
      setEnabled(calculation?.enabled || false);
    }
  }, [isOpen, calculation]);

  const handleSubmit = async () => {
    const payload = {
      name,
      enabled,
      result: null,
      function: null,
      functiontags: null,
    };

    setIsSubmitting(true); // İşlem başladığında butonları devre dışı bırak
    try {
      if (calculation) {
        await UpdateCalculation(calculation.id, payload);
        toast({
          title: 'Success',
          description: 'Calculation updated successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        await CreateCalculation(payload);
        toast({
          title: 'Success',
          description: 'Calculation created successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
      onSuccess(); // Listeyi güncelle
      onClose(); // Modalı kapat
    } catch (error) {
      const errorMessage =
        error.response?.data || 'An unexpected error occurred.';
      toast({
        title: 'Error',
        description: errorMessage,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false); // Butonları yeniden etkinleştir
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {calculation ? 'Edit Calculation' : 'Add Calculation'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4}>
            <FormLabel>Name</FormLabel>
            <Input
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Enter calculation name"
            />
          </FormControl>
          <FormControl>
            <Checkbox
              isChecked={enabled}
              onChange={e => setEnabled(e.target.checked)}
            >
              Enabled
            </Checkbox>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isLoading={isSubmitting}
          >
            Save
          </Button>
          <Button variant="ghost" onClick={onClose} isDisabled={isSubmitting}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CalculationModalComponent;
